<ion-content>
  <app-data-list [slidingOptions]="instanceSlidingOptions" [items]="viewModel">
  </app-data-list>
</ion-content>